import { useRef } from 'react';
import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import SecondaryNavBarLink from './SecondaryNavBarLink';

const Nav = styled('nav')`
  background-color: ${theme.colors.neutral[100]};
  width: 100%;
  display: flex;
  padding: 0 ${legacyTheme.spacing.s16};
  justify-content: center;
  border-bottom: solid 1px ${theme.colors.primary['100']};
  position: sticky;
  top: 95px;
  z-index: 11;
  ul {
    display: flex;
    position: relative;
    top: 2px;
    overflow-x: auto;
    list-style: none;
    transition: 0.2s ease;
    /* don't show the horizontal scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      padding-right: 35px;
      white-space: nowrap;
    }
  }

  ${legacyTheme.breakpoints.up('md')} {
    display: inline-block;
    ul {
      justify-content: center;
      li {
        white-space: nowrap;
        padding: 0 30px;
      }
    }
  }
`;
const SecondaryNavBar = ({ entries, dataTestId, scrollMarginTop }) => {
  const ref = useRef();
  return (
    <Nav ref={ref} data-testid={dataTestId}>
      <ul>
        {entries.map(entry => (
          <li key={entry.testId}>
            <SecondaryNavBarLink link={entry} scrollMarginTop={scrollMarginTop} />
          </li>
        ))}
      </ul>
    </Nav>
  );
};

SecondaryNavBar.defaultProps = {
  scrollMarginTop: '95px',
};

SecondaryNavBar.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      isActive: PropTypes.bool,
    }).isRequired
  ).isRequired,
  dataTestId: PropTypes.string.isRequired,
  scrollMarginTop: PropTypes.string,
};

export default SecondaryNavBar;
